module.exports = __webpack_public_path__ + "static/media/sur_platea(1).bd9d02b1.jpg";